/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import Calendar from './calendar/he_IL';
import DatePicker from './date-picker/he_IL';
import Pagination from './pagination/he_IL';
import TimePicker from './time-picker/he_IL';

export default {
  locale: 'he',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: '×ª×¤×¨×× ×¡×× ××',
    filterConfirm: '×××©××¨',
    filterReset: '×××¤××¡',
    selectAll: '×××¨ ×××',
    selectInvert: '××¤×× ××××¨×'
  },
  Modal: {
    okText: '×××©××¨',
    cancelText: '×××××',
    justOkText: '×××©××¨'
  },
  Popconfirm: {
    okText: '×××©××¨',
    cancelText: '×××××'
  },
  Transfer: {
    searchPlaceholder: '××¤×© ×××',
    itemUnit: '×¤×¨××',
    itemsUnit: '×¤×¨××××'
  },
  Upload: {
    uploading: '××¢××...',
    removeFile: '××¡×¨ ×§×××¥',
    uploadError: '×©××××ª ××¢×××',
    previewFile: '××¦× ×§×××¥'
  },
  Empty: {
    description: '××× ××××¢'
  }
};
